export default {
  Title: 'Work Experience',
  Subtitle: 'Professional background and career progression',
  Timeline: {
    YearFormat: `#{years} year`,
    YearMonthFormat: `#{years} years, #{months} months`,
    MonthFormat: `#{months} months`,
  },
  EndDatePresent: 'Present',
};
